/** @jsx jsx */
/**
 * * Project Name : eco presence
 * * Layer Name : UI
 * * Section : Grid 2 row 4 column alt. section
 * * Parent : section content
 * Description : design Grid 2 row 4 column alt. section primary admin with Database
 * Author: Suryakanta sahu
 * Date Created: 16-08-2022
 *
 *
 *
 *
 *
 */
/** ------------------ Primary Import Declaration -------- */
import React, { useEffect, useState, useContext } from "react";
import { css, jsx } from "@emotion/react";
import { useNavigate } from "react-router-dom";
/* ---------------------- MUI Components & APIs ----------------*/
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
/** ------------------ User Components ------------------- */
import { postRecord } from "services/services";
import { AuthContext } from "context/Authentication";

const API_GetAllCategories = "productcategories/getall";

export default function AllCategory(props) {
  const context = useContext(AuthContext);
  const isDigital =
    context.state?.companyInfo?.Product_Service_Type === "Product - Digital";

  const [allCategoryData, setAllCategoryData] = useState([]);
  const [visibleItems, setVisibleItems] = useState(12);
  const [showMore, setShowMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const fetchCategories = async () => {
      try {
        const response = await postRecord(API_GetAllCategories, {});
        if (isMounted) {
          if (response.status === 200 && response.data) {
            const categories = response.data
              .filter((x) => x.Is_Published === "1" && x.On_Homepage === "1")
              .map((category) => ({
                image: JSON.parse(category.Category_Media_Files)[0],
                title: category.Category_Name,
                description: category.Short_Description,
                categoryType: category.Category_Type, // Include category type
              }));
            setAllCategoryData(categories);
          }
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching categories:", error);
          setLoading(false);
        }
      }
    };

    fetchCategories();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleToggleView = () => {
    setShowMore(!showMore);
    setVisibleItems(showMore ? 12 : allCategoryData.length);
  };

  const handleCategoryClick = (category) => {
    const formattedCategoryName = category.title
      .toLowerCase()
      .replace(/ /g, "-");

    // Redirect based on category type
    if (category.categoryType === "Service") {
      navigate(`/ServiceList/${formattedCategoryName}`);
    } else {
      // Default to ProductList for 'Product' type or if type is missing
      navigate(`/ProductList/${formattedCategoryName}`);
    }
  };

  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Box sx={{ position: "relative", py: 3, px: 2, textAlign: "center" }}>
          <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
            {isDigital ? "All Genres" : "All Categories"}
          </Typography>
          <Box
            sx={{
              width: "80px",
              height: "2px",
              backgroundColor: "primary.main",
              mx: "auto",
              mb: 2,
            }}
          />
          <Grid container spacing={2} justifyContent="center">
            {loading
              ? // Skeleton loading placeholders
                Array.from(new Array(12)).map((_, index) => (
                  <Grid item xs={12} sm={6} md={2} lg={2} xl={2} key={index}>
                    <Card sx={{ borderRadius: "12px" }}>
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={150}
                        animation="wave"
                        sx={{ borderRadius: "8px 8px 0 0" }}
                      />
                      <CardContent>
                        <Skeleton animation="wave" height={24} width="70%" />
                        <Skeleton animation="wave" height={18} width="90%" />
                        <Skeleton animation="wave" height={18} width="50%" />
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              : allCategoryData &&
                allCategoryData.length > 0 &&
                allCategoryData
                  .slice(0, visibleItems)
                  .map((category, index) => (
                    <Grid item xs={12} sm={6} md={2} lg={2} xl={2} key={index}>
                      <Card
                        sx={{
                          transition: "all 1s ease-in-out",
                          backdropFilter: "blur(10px)",
                          borderRadius: "12px",
                          cursor: "pointer",
                          "&:hover": {
                            transform: "scale(1.05)",
                          },
                        }}
                        onClick={() => handleCategoryClick(category)}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            height: "200px",
                            backgroundImage: `url(${encodeURI(
                              process.env.BASEURL + category.image
                            )})`,
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "top",
                            mb: "10px",
                            borderRadius: "8px",
                          }}
                        />
                        <CardContent
                          sx={{
                            textAlign: "left",
                            paddingTop: "5px",
                            paddingBottom: 0,
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ fontWeight: "bold", mb: "5px" }}
                          >
                            {category.title}
                          </Typography>
                          <Typography variant="body2">
                            {category.description.length > 40
                              ? category.description.slice(0, 40) + "..."
                              : category.description}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
          </Grid>
        </Box>
      </Container>
    </React.Fragment>
  );
}
